// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AwsEksLogging } from './AwsEksLogging';
import {
  AwsEksLoggingFromJSON,
  AwsEksLoggingFromJSONTyped,
  AwsEksLoggingToJSON,
  AwsEksLoggingToJSONTyped,
} from './AwsEksLogging';
import type { AwsEksNodeGroup } from './AwsEksNodeGroup';
import {
  AwsEksNodeGroupFromJSON,
  AwsEksNodeGroupFromJSONTyped,
  AwsEksNodeGroupToJSON,
  AwsEksNodeGroupToJSONTyped,
} from './AwsEksNodeGroup';

/**
 *
 * @export
 * @interface AwsEks
 */
export interface AwsEks {
  /**
   *
   * @type {AwsEksLogging}
   * @memberof AwsEks
   */
  logging?: AwsEksLogging;
  /**
   *
   * @type {string}
   * @memberof AwsEks
   */
  masterVersion?: string;
  /**
   *
   * @type {Array<AwsEksNodeGroup>}
   * @memberof AwsEks
   */
  nodeGroups?: Array<AwsEksNodeGroup>;
  /**
   *
   * @type {Array<string>}
   * @memberof AwsEks
   */
  zones?: Array<string>;
}

/**
 * Check if a given object implements the AwsEks interface.
 */
export function instanceOfAwsEks(value: object): value is AwsEks {
  return true;
}

export function AwsEksFromJSON(json: any): AwsEks {
  return AwsEksFromJSONTyped(json, false);
}

export function AwsEksFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AwsEks {
  if (json == null) {
    return json;
  }
  return {
    logging:
      json['logging'] == null
        ? undefined
        : AwsEksLoggingFromJSON(json['logging']),
    masterVersion:
      json['master_version'] == null ? undefined : json['master_version'],
    nodeGroups:
      json['node_groups'] == null
        ? undefined
        : (json['node_groups'] as Array<any>).map(AwsEksNodeGroupFromJSON),
    zones: json['zones'] == null ? undefined : json['zones'],
  };
}

export function AwsEksToJSON(json: any): AwsEks {
  return AwsEksToJSONTyped(json, false);
}

export function AwsEksToJSONTyped(
  value?: AwsEks | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    logging: AwsEksLoggingToJSON(value['logging']),
    master_version: value['masterVersion'],
    node_groups:
      value['nodeGroups'] == null
        ? undefined
        : (value['nodeGroups'] as Array<any>).map(AwsEksNodeGroupToJSON),
    zones: value['zones'],
  };
}
